<template>
    <div class="order-detail">
        <div class="order-detail-header">
            <img :src="require('assets/img/order/kuaidi.png')"/>
            <div>
                {{trackingtips}}
            </div>
        </div>
        <div class="order-detail-body">
            <Cell icon="free-postage" center is-link @click="getExpressDetail" v-if="trackingstate!==-1">
                <div v-bind:click="getExpressDetail">
                    {{orderinfo.express}}:{{orderinfo.trackingno}}
                </div>
            </Cell>
            <Cell icon="location-o" center>
                <div slot="title">收货人:{{orderinfo.name}} {{orderinfo.mobile}}</div>
                <div slot="label">{{orderinfo.city}}{{orderinfo.district}}{{orderinfo.address}}</div>
            </Cell>
        </div>
        <div class="order-detail-goods">
            <Cell class="order-detail-goods-sku" center :value="orderinfo.gname">
                <img :src="orderinfo.gimgurl" slot="icon" style="margin-right:.3rem;"/>
            </Cell>
            <CellGroup>
                <Cell title="支付金额" v-if="orderinfo.payprice*1>0">
                    <div slot="default">
                        ¥ {{orderinfo.payprice}}
                    </div>
                </Cell>
                <Cell title="支付健康值">
                    <div slot="default">
                        {{orderinfo.selfpoint}}
                    </div>
                </Cell>

                <Cell title="订单编号" center :value="orderinfo.orderno"/>
                <Cell title="下单时间">
                    <div slot="default">
                        {{orderinfo.paytime}}
                    </div>
                </Cell>

            </CellGroup>
        </div>

        <!--        步骤条-->

        <Popup
                v-model="expressdetail"
                :style="{ height: '100%',width:'100%' }"
        >
            <Icon name="close" size="24" style="position:fixed;z-index:2003;right:.2rem;top:.2rem;"
                  @click="expressdetail=false"/>
            <Steps direction="vertical" :active="expressList.length-1">
                <Step v-for="(item,index) in expressList" :key="index">
                    <h3>{{item.context}}</h3>
                    <p>{{item.time}}</p>
                </Step>
            </Steps>
        </Popup>


    </div>

</template>
<script>
    import './index.less'
    import {Cell, CellGroup, Step, Steps, Popup, Icon} from 'vant'

    export default {
        data() {
            return {
                expressList: [],
                orderid: '',
                type: 2,
                orderinfo: '',
                trackingstate: '-1',
                trackingtips: '',
                expressdetail: false
            }
        },
        components: {
            Cell,
            CellGroup,
            Step,
            Steps,
            Popup,
            Icon
        },
        methods: {
            getExpressDetail: function () {
                this.expressdetail = true;
            },
            godetail: function () {
                let goodsid = this.data.orderinfo.gid;
                this.$router.push({name: "exchangedetail", params: {goodsid}})
            },
            getOrderDetail() {
                this.$api.pay.orderDetail({orderid: this.orderid, type: this.type}).then((res) => {
                    if (res.status * 1 === 200) {
                        let trackingtips = '订单处理中';
                        let trackingstate = -1;

                        if (res.data.trackingno !== '' && res.data.express !== '') {
                            if (!res.data.selfpoint) {
                                res.data.selfpoint = res.data.point;
                            }
                            this.$api.user.expressinfo({
                                orderno: res.data.orderno,
                                ordertype: this.type
                            }).then((res) => {
                                if (res.status * 1 === 200) {
                                    // 0-无轨迹，1-已揽收，2-在途中，3-签收,4-问题件
                                    switch (res.data.state * 1) {
                                        case 0:
                                            trackingtips = "无轨迹";
                                            break;
                                        case 1:
                                            trackingtips = "已揽收";
                                            break;
                                        case 2:
                                            trackingtips = "在途中";
                                            break;
                                        case 3:
                                            trackingtips = "签收";
                                            break;
                                        case 4:
                                            trackingtips = "问题件";
                                            break;
                                        default:
                                            trackingtips = " - ";
                                            break;

                                    }
                                    trackingstate = res.data.state;
                                    // //保存缓存
                                    // this.$storage.set({
                                    //     key: "expressinfo",
                                    //     data: res.data.list
                                    // })
                                    this.expressList = res.data.list

                                }
                                this.trackingtips = trackingtips
                                this.trackingstate = trackingstate

                            })


                        } else {
                            this.trackingtips = trackingtips
                            this.trackingstate = trackingstate
                        }
                        res.data.gname = res.data.detail[0].gname;
                        res.data.gimgurl = res.data.detail[0].gpimgurl;
                        res.data.gid = res.data.detail[0].gid;
                        this.orderinfo = res.data;


                    }

                })
            },
        },

        mounted: function () {
            this.orderid = this.$route.params.orderid;
            this.getOrderDetail();
        },
    }
</script>
